export default __webpack_public_path__ + "images/45173bc86b0cb5fa4a88fdb6a88b76ba-aov-select.svg";